import { render, staticRenderFns } from "./component-games-list-slick.vue?vue&type=template&id=f99a1882&scoped=true"
import script from "./component-games-list-slick.vue?vue&type=script&lang=js"
export * from "./component-games-list-slick.vue?vue&type=script&lang=js"
import style0 from "./component-games-list-slick.vue?vue&type=style&index=0&id=f99a1882&prod&lang=scss&scoped=true"
import style1 from "./component-games-list-slick.vue?vue&type=style&index=1&id=f99a1882&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a1882",
  null
  
)

export default component.exports